import { render, staticRenderFns } from "./activity-status-label.vue?vue&type=template&id=2c187fd3&scoped=true"
import script from "./activity-status-label.vue?vue&type=script&lang=js"
export * from "./activity-status-label.vue?vue&type=script&lang=js"
import style0 from "./activity-status-label.vue?vue&type=style&index=0&id=2c187fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c187fd3",
  null
  
)

export default component.exports